<template>
  <div class="LegendCtrl" @click="handleClick">
    Legenda
  </div>
</template>

<script>
export default {
  name: 'LegendCtrl',
  methods: {
    handleClick() {
      this.$emit('open')
    }
  }
}
</script>

<style lang="scss">
.LegendCtrl {
  position: absolute;
  top: 10px;
  left: 10px;
  font: 12px/20px Helvetica Neue,Arial,Helvetica,sans-serif;
  border-radius: 4px;
  background: #fff;
  box-shadow: 0 0 0 2px rgba(0,0,0,.1);
  outline: none;
  padding: 4px 5px 5px;
  cursor: pointer;
  user-select: none;

  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  &:hover:before {
    background-color: rgba(0,0,0,.05)
  }
}

</style>